import React from 'react';

const MoveUpIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
             height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'}
             strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
             strokeLinejoin="round"
        >
            <path d="M8 6L12 2L16 6"/>
            <path d="M12 2V22"/>
        </svg>
    );
};

export default MoveUpIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/MoveUpIcon.jsx